import { MomentMonthEnum } from "src/app/shared/enums/MomentMonthIndexEnum";

export class RomanMonths {
    public static readonly MONTHS: string[] = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

    public static toRoman(monthNumber: number): string {
      let arrayElement = monthNumber - 1;

      if (arrayElement < MomentMonthEnum.January || arrayElement > MomentMonthEnum.December)
          throw new Error("Miesiąc musi być w zakresie 1-12");
      
      return RomanMonths.MONTHS[arrayElement];
  }
}